import dynamic from 'next/dynamic';
import { decodeProfileValues } from '@pkgs/api/utils';

import { useShouldHideUserAccountExclusiveContent } from '@/hooks/useShouldHideUserAccountExclusiveContent';
import { useListing } from '@/hooks/queries/useListing';

const CourtagePassus = dynamic(
  () => import('@/components/property-expose/CourtagePassus/CourtagePassus').then((mod) => mod.CourtagePassus),
  {
    ssr: false,
  },
);

export const DynamicCourtagePassus = () => {
  const isUAExclusiveListingAndNotSignedIn = useShouldHideUserAccountExclusiveContent();
  const {
    data: { listing },
  } = useListing();
  if (!listing || isUAExclusiveListingAndNotSignedIn) return null;

  const profile = decodeProfileValues(listing.profile);

  if (!profile.courtagePassus) return null;

  return <CourtagePassus listing={listing} />;
};
